import request from "@/utils/request";

export default{
    // 增删改查
    createMerchandise(data){
        return request.post('/api/merchandises' , data);
    },
    deleteMerchandise(merchandiseId){
        return request.delete(`/api/merchandises/${merchandiseId}`);
    },
    batchDeleteMerchandises(merchandiseIds){
        return request.delete(`/api/merchandises/batch` , {
            data: {merchandise_ids: merchandiseIds}
        });
    },
    updateMerchandise(merchandiseId , data){
        return request.put(`/api/merchandises/${merchandiseId}` , data);
    },
    inquireMerchandise(merchandiseId){
        return request.get(`/api/merchandises/${merchandiseId}`);
    },
    inquireMerchandises(params){
        return request.get("/api/merchandises" , {params})
    }
};
